import { render, staticRenderFns } from "./View.vue?vue&type=template&id=1d0ab99f&scoped=true"
import script from "./View.vue?vue&type=script&lang=ts"
export * from "./View.vue?vue&type=script&lang=ts"
import style0 from "./View.vue?vue&type=style&index=0&id=1d0ab99f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ab99f",
  null
  
)

export default component.exports